<div class="container h-100" *transloco="let t; read: 'ime.login.email-password'">
  <div class="row align-items-center justify-content-center h-100">
    <div class="col-sm-6">
      <div class="card">
        <div class="card-body p-4">
          <form (submit)="loginWithPassword()">
            <div class="input-group my-4">
              <input type="email" name="email" [(ngModel)]="email" class="form-control form-control-lg" placeholder="{{t('E-mail')}}">
            </div>
            <div class="input-group my-4">
              <input type="password" name="password" [(ngModel)]="password" class="form-control form-control-lg" placeholder="{{t('Salasõna')}}">
              <button class="btn btn-primary px-4" type="submit">{{t('Sisene')}}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
